<div class="padding-l60 padding-b10">
    <button (click)="checkout()"
     style="color:white" class="primary"
      mat-flat-button>PAY NOW</button>
  </div>